var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('dog-square-tokens',{attrs:{"select":true}}),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }